export var FOCUSABLES = [
    "a[href]:not([tabindex='-1'])",
    "area[href]:not([tabindex='-1'])",
    "input:not([disabled]):not([tabindex='-1'])",
    "select:not([disabled]):not([tabindex='-1'])",
    "textarea:not([disabled]):not([tabindex='-1'])",
    "button:not([disabled]):not([tabindex='-1'])",
    "iframe:not([tabindex='-1'])",
    "[tabindex]:not([tabindex='-1'])",
    "[contentEditable=true]:not([tabindex='-1'])"
];
export var MAX_MOBILE_WIDTH = 768;
export var MAX_PHONE_WIDTH = 600;
export var HREF_DEFAULT = 'javascript:void(0)';
